import { render, staticRenderFns } from "./LoginCheckbox.vue?vue&type=template&id=0506ce03&scoped=true"
import script from "./LoginCheckbox.vue?vue&type=script&lang=ts"
export * from "./LoginCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./LoginCheckbox.vue?vue&type=style&index=0&id=0506ce03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506ce03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
